import React, { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import CartItemDropdownListItem from './cartItemDropdownListItem';
import CartItemChild from './cartItemChild'
import { ICartItem } from '../../interfaces/cartItem';

type CartItemDropdownListProps = {
    displayVerticalLine: boolean,
    chevronLeft: boolean,
    alwaysFullWidth: boolean,
    buttonContent: any,
    childrenItems: any,
    open: boolean,
    customeText?: string,
    submittedKitQty?: number
}

export const CartItemDropdownList = (props: CartItemDropdownListProps) => {

    const [open, setOpen] = useState(props.open);
    const internalDisplayVerticalLine = props.displayVerticalLine

    const getCartItemTotal = (cartItem: ICartItem) => {
        const qty = cartItem.qty;
        const kitItemQty = cartItem.kitItemQty;
        let originalComponentQuantity = qty / kitItemQty;

        let itemTotal = cartItem.qty * cartItem.sellPrice;
        if (props.submittedKitQty) {
            cartItem.submittedKitQty = props.submittedKitQty;
            originalComponentQuantity =
                originalComponentQuantity * props.submittedKitQty;
            itemTotal = originalComponentQuantity * cartItem.sellPrice;
        }

        return itemTotal;
    }
    const getCartItemDiscountTotal = (cartItem: ICartItem) => {
        let discountTotal = -1;

        if (
            cartItem.discount &&
            cartItem.discountType === 1 &&
            cartItem.discount > 0
        ) {
            discountTotal = getCartItemTotal(cartItem) - cartItem.discount;
        }

        return discountTotal;
    }

    const mapChildCartItems = (childrenItems: ICartItem[]) => {
        return (
            <>
                {childrenItems.map((childItem: ICartItem, index: number) => {
                    const key = `cart.${childItem.cartLineRecId}.${index}`;
                    const itemTotal = getCartItemTotal(childItem);
                    const discountTotal = getCartItemDiscountTotal(childItem);

                    return (
                        <CartItemDropdownListItem key={key}>
                            <CartItemChild
                                cartItem={childItem}
                                itemTotal={itemTotal}
                                discountTotal={discountTotal}
                                useMobile={props.alwaysFullWidth}
                            />
                        </CartItemDropdownListItem>
                    );
                })}
            </>
        );
    }

    const chevronBtnDivClasses = props.alwaysFullWidth ? "offset-6 col-6" : "offsetm-6 colm-6"
    const chevronLeftOrRightCls = props.chevronLeft ? "wbmcid-chevron-left" : "wbmcid-chevron-right"
    const widthCls = props.alwaysFullWidth ? "wbmcid-full-width" : "wbmcid-medium-width"
    const chevronDownCls = `wbmcid-chevron ${open ? "wbmcid-is-open" : ''}`

    return (
        <>
            <div className={`row no-gutters wbmcid-dropdown-button ${chevronLeftOrRightCls} ${widthCls}`}>
                <div className={chevronBtnDivClasses}>
                    <button
                        onClick={() => setOpen(!open)}
                        className={internalDisplayVerticalLine ? "" : "no-vert-line"}
                    >
                        <ExpandMoreIcon className={chevronDownCls} />
                        {internalDisplayVerticalLine && (
                            <div className="wbmcid-chevron-d wbmcid-chevron"></div>
                        )}
                        {props.buttonContent}
                    </button>
                </div>
            </div>
            {open && props.childrenItems && (
                <div className="wbmcid-dropdown-wrapper">
                    {mapChildCartItems(props.childrenItems)}
                    {  props.customeText && <CartItemDropdownListItem key='customeTextKey'>
                        <div className='custom-text-wrapper'>
                            <ErrorOutlineIcon />
                            <span className="custom-text">
                                {props.customeText}
                            </span>
                        </div>
                    </CartItemDropdownListItem>}
                </div>
            )}

        </>
    );
};